// Open Action Text Trix attachments or links in new window
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        const articlePaths = ['/articles/', '/bai-viet/', '/ja/articles/', '/ko/articles/', '/zh-cn/articles/', '/en/articles/', '/es/articulos/', '/pt/artigos/', '/de/artikel/', '/tl/mga-artikulo/', '/id/artikel/'];

        this.element.querySelectorAll('a').forEach(function(link) {
            const isArticlePage = articlePaths.some(path => link.pathname.includes(path));

            // If it's an internal article link, keep it on the same page
            if (isArticlePage) {
                link.turbo = true;
                // Don't set target="_blank"
            } else {
                // External links or non-article internal links open in new tab
                link.turbo = false;
                link.target = "_blank";
            }
        })
    }
}
